import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";
import noop from "lodash/noop";
import OutsideClickHandler from "@xo-union/component-outside-click";
import { withClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import Field from "../../../Field/index.js";
import SuggestionContainer from "../SuggestionContainer/index.js";
import SuggestionList from "../SuggestionList/index.js";
import { DOWN, UP, RETURN, ESC, TAB } from "../../utils/keyCode.js";
import labelize from "../../utils/labelize.js";
import styles from "../../styles.css";

var AsyncTypeahead =
/*#__PURE__*/
function (_Component) {
  _inherits(AsyncTypeahead, _Component);

  function AsyncTypeahead(props) {
    var _this;

    _classCallCheck(this, AsyncTypeahead);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AsyncTypeahead).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "hideSuggestions", function () {
      _this.setState({
        showSuggestions: false,
        activeIndex: -1
      });
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      var query = _this.state.query;

      _this.input.focus();

      _this.input.setSelectionRange(query.length, query.length);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var query = e.target.value;

      _this.setState({
        showSuggestions: true,
        activeIndex: -1
      });

      _this.updateQuery(query);

      _this.handleSearchDebounced(_trimInstanceProperty(query).call(query));
    });

    _defineProperty(_assertThisInitialized(_this), "handleSuggestionClick", function (e, suggestion) {
      var labelKey = _this.props.labelKey;
      var query = _this.state.query;
      var newQuery = labelize(suggestion, labelKey) || query;

      _this.updateSelected(suggestion);

      _this.updateQuery(newQuery); // TODO: MH - Don't do this extra call.
      // Currently used to update the suggestions after suggestion selection.


      _this.handleSearchDebounced(_trimInstanceProperty(newQuery).call(newQuery));

      _this.hideSuggestions();
    });

    _defineProperty(_assertThisInitialized(_this), "handleListNavigation", function (e) {
      var suggestions = _this.props.suggestions;
      var _this$state = _this.state,
          showSuggestions = _this$state.showSuggestions,
          activeIndex = _this$state.activeIndex;
      if (!showSuggestions) return;
      e.preventDefault();
      var newActiveIndex = activeIndex; // Increment or decrement index based on user keystroke.

      newActiveIndex += e.keyCode === UP ? -1 : 1; // If we've reached the end, go back to the beginning or vice-versa.

      if (newActiveIndex === suggestions.length) {
        newActiveIndex = -1;
      } else if (newActiveIndex === -2) {
        newActiveIndex = suggestions.length - 1;
      }

      _this.setState({
        activeIndex: newActiveIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEsc", function (e) {
      e.preventDefault();

      _this.hideSuggestions();
    });

    _defineProperty(_assertThisInitialized(_this), "handleTab", function (e) {
      var suggestions = _this.props.suggestions;
      var _this$state2 = _this.state,
          showSuggestions = _this$state2.showSuggestions,
          selected = _this$state2.selected;

      if (showSuggestions && suggestions.length > 0 && suggestions[0] !== selected) {
        e.preventDefault();

        _this.handleSuggestionClick(e, suggestions[0]);
      }

      _this.hideSuggestions();
    });

    _defineProperty(_assertThisInitialized(_this), "handleReturn", function (e) {
      var suggestions = _this.props.suggestions;
      var _this$state3 = _this.state,
          showSuggestions = _this$state3.showSuggestions,
          activeIndex = _this$state3.activeIndex;
      if (!showSuggestions || activeIndex === -1) return;
      e.preventDefault();

      _this.handleSuggestionClick(e, suggestions[activeIndex]);
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var _handlers;

      var handlers = (_handlers = {}, _defineProperty(_handlers, UP, _this.handleListNavigation), _defineProperty(_handlers, DOWN, _this.handleListNavigation), _defineProperty(_handlers, ESC, _this.handleEsc), _defineProperty(_handlers, TAB, _this.handleTab), _defineProperty(_handlers, RETURN, _this.handleReturn), _handlers);
      if (handlers[e.keyCode]) handlers[e.keyCode](e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      var _this$props = _this.props,
          suggestions = _this$props.suggestions,
          onFocus = _this$props.onFocus;
      onFocus(e);

      _this.setState({
        showSuggestions: suggestions.length > 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSuggestionList", function () {
      var activeIndex = _this.state.activeIndex;

      var _this$props2 = _this.props,
          renderSuggestionList = _this$props2.renderSuggestionList,
          classes = _this$props2.classes,
          rest = _objectWithoutProperties(_this$props2, ["renderSuggestionList", "classes"]);

      var suggestionListProps = _objectSpread({}, rest, {
        emptyLabel: _this.getEmptyLabel(),
        activeIndex: activeIndex,
        onSuggestionClick: _this.handleSuggestionClick
      });

      var containerContents = renderSuggestionList ? renderSuggestionList(suggestionListProps) : React.createElement(SuggestionList, _extends({
        classes: classes
      }, suggestionListProps));
      return React.createElement(SuggestionContainer, {
        classes: classes
      }, containerContents);
    });

    _defineProperty(_assertThisInitialized(_this), "inputRef", function (input) {
      _this.input = input;
    });

    _this.state = AsyncTypeahead.getInitialState(props);
    return _this;
  }

  _createClass(AsyncTypeahead, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        activeIndex: this.state.activeIndex,
        onSuggestionClick: this.handleSuggestionClick
      };
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.handleSearchDebounced = debounce(this.handleSearch, this.props.delay);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps() {
      var requestPending = this.state.requestPending;

      if (requestPending) {
        this.setState({
          requestPending: false
        });
      }
    }
  }, {
    key: "getEmptyLabel",
    value: function getEmptyLabel() {
      var _this$props3 = this.props,
          searchText = _this$props3.searchText,
          emptyLabel = _this$props3.emptyLabel;
      var requestPending = this.state.requestPending;
      return requestPending ? searchText : emptyLabel;
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(query) {
      var _this2 = this;

      this.setState({
        requestPending: true
      }, function () {
        return _this2.props.onSearch(query);
      });
    }
  }, {
    key: "updateQuery",
    value: function updateQuery(query) {
      var onInputChange = this.props.onInputChange;
      this.setState({
        query: query
      });
      if (onInputChange) onInputChange(query);
    }
  }, {
    key: "updateSelected",
    value: function updateSelected(selected) {
      var onChange = this.props.onChange;
      this.setState({
        selected: selected
      });
      if (onChange) onChange(selected);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state4 = this.state,
          query = _this$state4.query,
          showSuggestions = _this$state4.showSuggestions,
          activeIndex = _this$state4.activeIndex;

      var _this$props4 = this.props,
          classes = _this$props4.classes,
          defaultInputValue = _this$props4.defaultInputValue,
          delay = _this$props4.delay,
          emptyLabel = _this$props4.emptyLabel,
          idKey = _this$props4.idKey,
          labelKey = _this$props4.labelKey,
          onInputChange = _this$props4.onInputChange,
          onSearch = _this$props4.onSearch,
          renderSuggestion = _this$props4.renderSuggestion,
          renderSuggestionList = _this$props4.renderSuggestionList,
          suggestions = _this$props4.suggestions,
          searchText = _this$props4.searchText,
          fieldClasses = _this$props4.fieldClasses,
          rest = _objectWithoutProperties(_this$props4, ["classes", "defaultInputValue", "delay", "emptyLabel", "idKey", "labelKey", "onInputChange", "onSearch", "renderSuggestion", "renderSuggestionList", "suggestions", "searchText", "fieldClasses"]);

      return React.createElement(OutsideClickHandler, {
        onOutsideClick: this.hideSuggestions
      }, React.createElement("div", {
        className: classes.container
      }, React.createElement(Field, _extends({}, rest, {
        inputRef: this.inputRef,
        value: labelize(suggestions[activeIndex], labelKey) || query,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        classes: fieldClasses
      })), showSuggestions && this.renderSuggestionList()));
    }
  }]);

  return AsyncTypeahead;
}(Component);

_defineProperty(AsyncTypeahead, "getInitialState", function (props) {
  return {
    query: props.defaultInputValue || '',
    showSuggestions: false,
    requestPending: false,
    activeIndex: -1,
    selected: null
  };
});

AsyncTypeahead.defaultProps = {
  defaultInputValue: null,
  delay: 200,
  emptyLabel: 'No matches found.',
  idKey: null,
  labelKey: 'label',
  onChange: null,
  onFocus: noop,
  onInputChange: null,
  onSearch: noop,
  renderSuggestion: null,
  renderSuggestionList: null,
  suggestions: [],
  searchText: 'Searching...'
};
process.env.NODE_ENV !== "production" ? AsyncTypeahead.propTypes = {
  /**
   * Specify the inputs default text.
   */
  defaultInputValue: PropTypes.string,

  /**
   * Delay, in milliseconds, before performing search.
   */
  delay: PropTypes.number,

  /**
   * Message to display in the menu if there are no valid results.
   */
  emptyLabel: PropTypes.string,

  /**
   * Specify the suggestion key to use for display or a function returning the display string.
   */
  labelKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Invoked whenever items is selected.
   */
  onChange: PropTypes.func,

  /**
   * Invoked when the input is focused. Receives an event.
   */
  onFocus: PropTypes.func,

  /**
   * Invoked when the input value changes.
   */
  onInputChange: PropTypes.func,

  /**
   * Callback to perform when the search is executed.
   */
  onSearch: PropTypes.func,

  /**
   * Provides a hook for customized rendering of suggestion item contents.
   */
  renderSuggestion: PropTypes.func,
  // TODO: Is this being used?

  /**
   * Provides a hook for customized rendering of the suggestions list.
   */
  renderSuggestionList: PropTypes.func,

  /**
   * Text displayed in the menu while the request is pending.
   */
  searchText: PropTypes.string,

  /**
   * Specify the suggestion key to use for uniquely identifying a suggestion.
   */
  idKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Full set of suggestions. Must either be an array of objects or strings.
   */
  suggestions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.arrayOf(PropTypes.string)]),

  /**
   * Classes dependencies
   */
  classes: classesPropType(['container', 'list-container', 'list', 'item', 'item-is-disabled', 'item-is-active']).isRequired,

  /**
   * Field Classes dependencies. See Field component for list of valid classes
   */
  fieldClasses: classesPropType().isRequired
} : void 0;
AsyncTypeahead.childContextTypes = {
  activeIndex: PropTypes.number.isRequired,
  onSuggestionClick: PropTypes.func.isRequired
};
export default withClasses(styles)(AsyncTypeahead);